import type { HttpClient } from '@/model';
import { decodeCall, encodePayload, object, type CallApi } from './call-wire';

export function createCallApi(http: HttpClient): CallApi {
  const options = (signal?: AbortSignal) => ({ signal: signal ? AbortSignal.any([signal, AbortSignal.timeout(15_000)]) : AbortSignal.timeout(15_000) });
  const envelope = (value: unknown) => decodeCall(object(value)?.call);
  const action = async (id: string, name: string) => envelope(await http.post(`/v1/calls/${encodeURIComponent(id)}/${name}`, {}, options()));
  return {
    start: async input => envelope(await http.post('/v1/calls', input, options())),
    active: async signal => {
      const raw = object(await http.get('/v1/calls/active', options(signal)));
      if (!Array.isArray(raw?.calls)) throw new Error('invalid_call');
      return raw.calls.map(decodeCall);
    },
    get: async (id, signal) => envelope(await http.get(`/v1/calls/${encodeURIComponent(id)}`, options(signal))),
    accept: id => action(id, 'accept'), decline: id => action(id, 'decline'), cancel: id => action(id, 'cancel'), end: id => action(id, 'end'),
    signal: async (id, type, payload) => { await http.post(`/v1/calls/${encodeURIComponent(id)}/signal`, { type, payload: encodePayload(payload) }, options()); },
  };
}
